import "./events.css";
import "../home/home.css";
import Masonry from "react-responsive-masonry";
import { public_gallery_img_list, public_gallery_list } from "../public.api";

import { useState, memo, useCallback, useEffect } from "react";
import Loader from "../../../components/loader/loader";
import Footer from "../../../layout/userlayout/components/footer/footer";
import BreadCrumpBack from "../../../components/navigator/back";
import SearchButton from "../../../components/buttons/search/search-btn";
const GalleryImages = (props) => {
  let lang = props.state.language;
  const [data, setData] = useState([]);
  const [url, setUrl] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [activeSelection, setActiveSelection] = useState(null);
  const [statuses, setStatuses] = useState([]);
  const [activeStatus, setActiveStatus] = useState("");
  const [searchDate, setSearchDate] = useState("");
  const [searchTitle, setSearchTitle] = useState("");
  const fetchEvents = () => {
    public_gallery_list().then((res) => {
      setData(res.data);
      setUrl(res.current_url);
      setIsActive(false);
    });
  };

  useEffect(() => {
    fetchEvents();
  }, []);
  const settingColumns = useCallback(() => {
    if (window.innerWidth >= 1400) return 4;
    if (window.innerWidth >= 800) return 3;
    if (window.innerWidth >= 500) return 2;
    return 1;
  }, []);

  const [column, setColumn] = useState(() => settingColumns());
  let fromHome = sessionStorage.getItem("continueFrom");
  useEffect(() => {
    window.scrollTo(0, 0);
    window.addEventListener("resize", () => setColumn(() => settingColumns()));

    return window.removeEventListener("resize", () =>
      setColumn(() => settingColumns())
    );
  }, [setColumn, settingColumns]);
  useEffect(() => {
    getStatusList();
  }, []);
  const getStatusList = () => {
    public_gallery_img_list().then((res) => {
      setStatuses(res.data);
      console.log(res);
    });
  };

  const handlePreview = (index, flag) => {
    if (flag) {
      setActiveSelection(index);
    } else {
      setActiveSelection(null);
    }
  };
  const keyBoardActions = (event) => {
    // setActiveSelection((c) => c);
    if (event.keyCode === 27) {
      handlePreview();
    }
    // } else if (event.keyCode === 37) {
    //   handleBackward(event);
    // } else if (event.keyCode === 39) {
    //   handleForward(event);
    // }
  };

  useEffect(() => {
    document.addEventListener("keydown", keyBoardActions);

    return () => {
      document.removeEventListener("keydown", keyBoardActions);
    };
  }, []);
  const handleBackward = (e) => {
    if (e) {
      e.stopPropagation();
    }
    setActiveSelection((c) => c);
    if (activeSelection) {
      let sel = Number(activeSelection);
      if (sel === 0) {
        setActiveSelection(`${data.length - 1}`);
      } else {
        setActiveSelection(`${sel - 1}`);
      }
    }
  };
  const handleForward = (e) => {
    if (e) {
      e.stopPropagation();
    }
    setActiveSelection((c) => c);
    let max = data.length - 1;
    if (activeSelection) {
      let sel = Number(activeSelection);
      console.log(sel);
      console.log(max);
      if (sel === max) {
        setActiveSelection("0");
      } else {
        setActiveSelection(`${sel + 1}`);
      }
    }
  };
  const manageStatus = (e) => {
    const { name, value } = e.target;

    if (name === "searchTitle") {
      setSearchTitle(value);
    } else if (name === "searchDate") {
      setSearchDate(value);
    }
  };

  const handleSearch = () => {
    const searchParams = searchTitle || searchDate || ""; // Use either title, date, or an empty string

    public_gallery_img_list(searchParams).then((res) => {
      let filteredArray = res.data;

      // Filter by Title
      if (searchTitle) {
        filteredArray = filteredArray.filter((data) =>
          data[lang]?.Title.toLowerCase().includes(searchTitle.toLowerCase())
        );
      }

      // Filter by Date
      if (searchDate) {
        filteredArray = filteredArray.filter(
          (data) => data[lang]?.date === searchDate
        );
      }

      setData(filteredArray);
    });
  };

  return (
    <div>
      <Loader open={isActive} />
      {activeSelection && (
        <div className="gallery-preview " onClick={() => handlePreview()}>
          <button
            className="close-button"
            onClick={(e) => {
              e.stopPropagation();
              setActiveSelection(null);
            }}
          >
            &times;
          </button>

          <img
            src={data[activeSelection][lang]?.images}
            className=" curser-zoomout full_img"
            alt=""
          />
          <div
            className="gallery-arrow left "
            onClick={(e) => handleBackward(e)}
          >
            &lt;
          </div>
          <div
            className="gallery-arrow right "
            onClick={(e) => handleForward(e)}
          >
            &gt;
          </div>
        </div>
      )}
      <div>
        {/* ======================= Events  =================================================================== */}
        <div className="container-fluid event-bg">
          <div className="row m-55">
            {/* <h3>Gallery</h3> */}
            <h3>Images</h3>
          </div>
        </div>
        <BreadCrumpBack />

        <div className="row font-z m-4 justify-content-end">
          <div className="col-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search by Title"
              name="searchTitle"
              value={searchTitle}
              onChange={manageStatus} // Updated function
            />
          </div>

          <div className="col-3">
            <input
              type="date"
              className="form-control"
              placeholder="Search by Date"
              name="searchDate"
              value={searchDate}
              onChange={manageStatus} // Updated function
            />
          </div>

          {/* Search Button */}
          <div className="col-2 d-flex">
            <SearchButton {...props} onClick={handleSearch} />
          </div>
        </div>

        <div className=" mtb-25">
          <div className="container gal-i ">
            <div className="row ">
              {/* <Masonry columnsCount={column} gutter="10px"> */}
              {data &&
                data.map((image, i) => (
                  <>
                    <div
                      key={i}
                      className="col-4 p-1 d-flex flex-column justify-content-between
                     gap-4 w-full"
                    >
                      <div
                        className="galary_img_title d-flex justify-content-center align-items-center text-center"
                        style={{
                          fontSize: "20px",
                          paddingLeft: "10px",
                          fontWeight: 700,
                        }}
                      >
                        {image[lang]?.Title}
                      </div>
                      <div style={{ objectFit: "contain" }}>
                        <img
                          key={i}
                          alt="gallery-kspace"
                          onClick={() => {
                            handlePreview(`${i}`, true);
                          }}
                          src={image[lang]?.images}
                          className="curser-zoomin cover_image "
                          style={{ marginBottom: "28px" }}
                        />
                      </div>
                    </div>
                    {(i + 1) % 3 === 0 && <hr />}
                  </>
                ))}
              {/* {data && data.length > 0 ? (
                data.map((image, i) => (
                  <>
                    <div
                      className="galary_img_title flex-1 "
                      style={{
                        fontSize: "20px",
                        paddingLeft: "10px",
                        fontWeight: "semibold",
                      }}
                    >
                      {image[lang]?.Title}
                    </div>

                    <div
                      key={i}
                      className="col-3 items-center flex w-full border rounded shadow-sm p-1"
                    >
                      <img
                        alt="gallery-kspace"
                        onClick={() => {
                          handlePreview(`${i}`, true);
                        }}
                        src={image[lang]?.images}
                        className="cursor-zoom-in cover_image"
                      />
                    </div>
                  </>
                ))
              ) : (
                <>
                  <div className="no-data">
                    <img src="resources/img/no1.png" alt="" />
                    <h4>No Records Found..!!</h4>
                  </div>
                </>
              )}
              {/* {data && data.length > 0 ? (
                data.map((image, i) => (
                  <>
                    <div
                      className="galary_img_title "
                      style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        padding: "5px 10px",
                      }}
                    >
                      {image[lang]?.Title}
                    </div>

                    <div className="col-4 p-1">
                      <img
                        key={i}
                        alt="gallery-kspace"
                        onClick={() => {
                          handlePreview(`${i}`, true);
                        }}
                        src={image[lang]?.images}
                        className="curser-zoomin cover_image"
                        style={{ objectFit: "cover !important" }}
                      />
                    </div>
                  </>
                ))
              ) : (
                <div className="no-data text-center">
                  <img src="resources/img/no1.png" alt="No records" />
                  <h4>No Records Found..!!</h4>
                </div>
              )} */}

              {/* </Masonry> */}
            </div>
          </div>
          {activeSelection !== null && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80">
              <div className="relative max-w-3xl w-full p-4">
                <button
                  onClick={() => setActiveSelection(null)}
                  className="absolute top-2 right-2 text-white text-2xl font-bold"
                >
                  &times;
                </button>
                {/* <img
              src={data[previewIndex][lang]?.images}
              alt={data[previewIndex][lang]?.Title || 'Image'}
              className="w-full h-auto rounded-lg"
            />
            <p className="mt-2 text-white text-center text-lg">
              {data[previewIndex][lang]?.Title}
            </p> */}
              </div>
            </div>
          )}
        </div>
        {/* <Footer /> */}
        {/* =================================================================================================== */}
      </div>
    </div>
  );
};
export default memo(GalleryImages);
